module.exports = __webpack_public_path__ + "img/icon_candidat.bb06a979.svg";